import Vue from 'vue';
import VueRouter from 'vue-router';
import DataTable from './components/DataTable.vue';
import HelloWorld from './components/HelloWorld.vue';
import LookUp from './components/LookUp.vue';
import Login from './components/Login.vue';
import AllComments from './components/AllComments.vue';
Vue.use(VueRouter);

const routes = [
  { path: '/', component: DataTable },
  { path: '/lookup', component: LookUp },
  { path: '/about', component: HelloWorld },
  { path: '/admin', component: Login, name: 'Login' },
  { path: '/all-comments', component: AllComments } // how to make this route render only if user is logged in?
];

const router = new VueRouter({
  mode: 'history',
  base: 'eqtl',
  routes
});

export default router;
